import { call, put, takeEvery, getContext } from "redux-saga/effects";

import { CONTEXT } from "@const/redux";
import {
  getMyFollowersSuccess,
  getMyFollowersFailure,
  getMyFollowersPortionSuccess,
  getMyFollowersPortionFailure,
  getMyFollowingsPortionSuccess,
  getMyFollowingsPortionFailure,
  getMyFollowingsSuccess,
  getMyFollowingsFailure,
  getFollowersByIdSuccess,
  getFollowersByIdFailure,
  getFollowersByIdPortionSuccess,
  getFollowersByIdPortionFailure,
  getFollowingsByIdSuccess,
  getFollowingsByIdFailure,
  getFollowingsByIdPortionFailure,
  getFollowingsByIdPortionSuccess,
  favoriteFollowingSuccess,
  unfavoriteFollowingSuccess,
  favoriteFollowingFailure,
  unfavoriteFollowingFailure,
  getMyFollowings as getMyFollowingsAction,
} from "./actions";
import {
  getFollowersByIdActionTypes,
  getFollowersByIdPortionActionTypes,
  getFollowingsByIdActionTypes,
  getFollowingsByIdPortionActionTypes,
  getMyFollowersActionTypes,
  getMyFollowersPortionActionTypes,
  getMyFollowingsActionTypes,
  getMyFollowingsPortionActionTypes,
  favoriteFollowingActionTypes,
  unfavoriteFollowingActionTypes,
} from "./actionTypes";

const getMyFollowersAsync = ({ UsersService, params }) => {
  if (!UsersService) {
    console.log("Required services does not exist");
    return null;
  }

  return UsersService.getMyFollowers(params);
};

function* getMyFollowers({ payload: params }) {
  try {
    const { UsersService } = yield getContext(CONTEXT.SERVICES);

    const { data, pagination } = yield call(getMyFollowersAsync, {
      UsersService,
      params,
    });

    yield put(getMyFollowersSuccess({ data, ...pagination }));
  } catch ({ error }) {
    yield put(getMyFollowersFailure(error));
  }
}

function* getMyFollowersPortion({ payload: params }) {
  try {
    const { UsersService } = yield getContext(CONTEXT.SERVICES);

    const { data, pagination } = yield call(getMyFollowersAsync, {
      UsersService,
      params,
    });

    yield put(getMyFollowersPortionSuccess({ data, ...pagination }));
  } catch ({ error }) {
    yield put(getMyFollowersPortionFailure(error));
  }
}

const getMyFollowingsAsync = ({ UsersService, params }) => {
  if (!UsersService) {
    console.log("Required services does not exist");
    return null;
  }

  return UsersService.getMyFollowings(params);
};

function* getMyFollowings({ payload: params }) {
  try {
    const { UsersService } = yield getContext(CONTEXT.SERVICES);

    const { data, pagination } = yield call(getMyFollowingsAsync, {
      UsersService,
      params,
    });

    yield put(getMyFollowingsSuccess({ data, ...pagination }));
  } catch ({ error }) {
    yield put(getMyFollowingsFailure(error));
  }
}

function* getMyFollowingsPortion({ payload: params }) {
  try {
    const { UsersService } = yield getContext(CONTEXT.SERVICES);

    const { data, pagination } = yield call(getMyFollowingsAsync, {
      UsersService,
      params,
    });

    yield put(getMyFollowingsPortionSuccess({ data, ...pagination }));
  } catch ({ error }) {
    yield put(getMyFollowingsPortionFailure(error));
  }
}

const getFollowersByIdAsync = ({ UsersService, id, params }) => {
  if (!UsersService) {
    console.log("Required services does not exist");
    return null;
  }

  return UsersService.followersByUserId(id, params);
};

function* getFollowersById({ payload }) {
  try {
    const { UsersService } = yield getContext(CONTEXT.SERVICES);
    const { id, ...params } = payload;

    const { data, pagination } = yield call(getFollowersByIdAsync, {
      UsersService,
      id,
      params,
    });

    yield put(getFollowersByIdSuccess({ data, ...pagination }));
  } catch ({ error }) {
    yield put(getFollowersByIdFailure(error));
  }
}

function* getFollowersByIdPortion({ payload }) {
  try {
    const { UsersService } = yield getContext(CONTEXT.SERVICES);
    const { id, ...params } = payload;

    const { data, pagination } = yield call(getFollowersByIdAsync, {
      UsersService,
      id,
      params,
    });

    yield put(getFollowersByIdPortionSuccess({ data, ...pagination }));
  } catch ({ error }) {
    yield put(getFollowersByIdPortionFailure(error));
  }
}

const getFollowingsByIdAsync = ({ UsersService, id, params }) => {
  if (!UsersService) {
    console.log("Required services does not exist");
    return null;
  }

  return UsersService.followingsByUserId(id, params);
};

function* getFollowingsById({ payload }) {
  try {
    const { UsersService } = yield getContext(CONTEXT.SERVICES);
    const { id, ...params } = payload;

    const { data, pagination } = yield call(getFollowingsByIdAsync, {
      UsersService,
      id,
      params,
    });

    yield put(getFollowingsByIdSuccess({ data, ...pagination }));
  } catch ({ error }) {
    yield put(getFollowingsByIdFailure(error));
  }
}

function* getFollowingsByIdPortion({ payload }) {
  try {
    const { UsersService } = yield getContext(CONTEXT.SERVICES);
    const { id, ...params } = payload;

    const { data, pagination } = yield call(getFollowingsByIdAsync, {
      UsersService,
      id,
      params,
    });

    yield put(getFollowingsByIdPortionSuccess({ data, ...pagination }));
  } catch ({ error }) {
    yield put(getFollowingsByIdPortionFailure(error));
  }
}

const favoriteFollowingAsync = ({ UsersService, followingId }) => {
  if (!UsersService) {
    console.log("Required services does not exist");
    return;
  }

  return UsersService.addFollowingToFavorite(followingId);
};

function* favoriteFollowing({ payload }) {
  try {
    const { UsersService } = yield getContext(CONTEXT.SERVICES);
    const { followingId, limit } = payload;

    yield call(favoriteFollowingAsync, {
      UsersService,
      followingId,
    });

    yield put(favoriteFollowingSuccess({ followingId }));
    yield put(getMyFollowingsAction({ limit }));
  } catch ({ error }) {
    yield put(favoriteFollowingFailure(error));
  }
}

const unfavoriteFollowingAsync = ({ UsersService, followingId }) => {
  if (!UsersService) {
    console.log("Required services does not exist");
    return;
  }

  return UsersService.removerFollowingFromFavorite(followingId);
};

function* unfavoriteFollowing({ payload }) {
  try {
    const { UsersService } = yield getContext(CONTEXT.SERVICES);

    const { followingId, limit } = payload;

    yield call(unfavoriteFollowingAsync, {
      UsersService,
      followingId,
    });

    yield put(unfavoriteFollowingSuccess({ followingId }));

    yield put(getMyFollowingsAction({ limit }));
  } catch ({ error }) {
    yield put(unfavoriteFollowingFailure(error));
  }
}

export function* watchGetMyFollowers() {
  yield takeEvery(getMyFollowersActionTypes.request, getMyFollowers);
}

export function* watchGetMyFollowersPortion() {
  yield takeEvery(
    getMyFollowersPortionActionTypes.request,
    getMyFollowersPortion,
  );
}

export function* watchGetMyFollowings() {
  yield takeEvery(getMyFollowingsActionTypes.request, getMyFollowings);
}

export function* watchGetMyFollowingsPortion() {
  yield takeEvery(
    getMyFollowingsPortionActionTypes.request,
    getMyFollowingsPortion,
  );
}

export function* watchFollowersById() {
  yield takeEvery(getFollowersByIdActionTypes.request, getFollowersById);
}

export function* watchFollowersByIdPortion() {
  yield takeEvery(
    getFollowersByIdPortionActionTypes.request,
    getFollowersByIdPortion,
  );
}

export function* watchFollowingsById() {
  yield takeEvery(getFollowingsByIdActionTypes.request, getFollowingsById);
}

export function* watchFollowingsByIdPortion() {
  yield takeEvery(
    getFollowingsByIdPortionActionTypes.request,
    getFollowingsByIdPortion,
  );
}

export function* watchFavoriteFollowing() {
  yield takeEvery(favoriteFollowingActionTypes.request, favoriteFollowing);
}

export function* watchUnfavoriteFollowing() {
  yield takeEvery(unfavoriteFollowingActionTypes.request, unfavoriteFollowing);
}
